exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categoryTagsShowMore {\n  display: flex;\n  position: relative;\n  margin-top: 10px;\n}\n\n.categoryTagsShowMore .chevron {\n  padding-left: 5px;\n}\n\n.categoryTagsShowMore_text {\n  color: #000000;\n  font-family: WorkSansMedium;\n  font-size: 10px;\n  font-weight: bold;\n  text-transform: uppercase;\n  margin: 0 25px;\n  line-height: 12px;\n  cursor: pointer;\n}\n\n.categoryTagsShowMore_horizontalDivide {\n  margin-top: 4px;\n  flex-grow: 1;\n  border-top: 1px solid #adadad;\n  opacity: 0.65;\n}\n", ""]);

// exports
